import "./Header.scss";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import { useRef, useState } from "react";
import { ENUMS } from "../../../enums/enums";
import AtmLink from "../../atoms/atmLink/AtmLink";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { i18n, t } = useTranslation();
  const mobileNav = useRef();
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleMobile = () => {
    if (mobileOpen) {
      mobileNav.current.style.height = "0";
    } else {
      mobileNav.current.style.height = `${mobileNav.current.scrollHeight}px`;
    }
    setMobileOpen(!mobileOpen);
  };

  const changeLanguage = () => {
    i18n
      .changeLanguage(i18n.language === "en" ? "mk" : "en")
      .then(
        () =>
          (mobileNav.current.style.height = `${mobileNav.current.scrollHeight}px`)
      );
  };

  return (
    <header className={"mdl-header"} data-mobile-open={mobileOpen}>
      <div className={"mdl-header-container"}>
        <Link to={"/"} className={"mdl-header__logo"}>
          <img src={logo} alt={"logo"} />
        </Link>

        <nav>
          <AtmLink inline to={ENUMS.ROUTE_ABOUT_US}>
            {t("aboutUs")}
          </AtmLink>
          <AtmLink inline to={ENUMS.ROUTE_SERVICES}>
            {t("services")}
          </AtmLink>
          <AtmLink inline to={ENUMS.ROUTE_OUR_PEOPLE}>
            {t("ourPeople")}
          </AtmLink>
          <AtmLink inline to={ENUMS.ROUTE_PROJECTS}>
            {t("projects")}
          </AtmLink>
          <AtmLink inline to={ENUMS.ROUTE_CAREERS}>
            {t("careers")}
          </AtmLink>
          <AtmLink inline to={ENUMS.ROUTE_CONTACT}>
            {t("contact")}
          </AtmLink>
          <div className={"mdl-header__lang"} onClick={changeLanguage}>
            {i18n.language === "en" ? "MK" : "EN"}
          </div>
        </nav>
        <button className={"mdl-header__burger"} onClick={toggleMobile}>
          <div className="bar1" />
          <div className="bar2" />
          <div className="bar3" />
        </button>
        <div className={"mdl-header-mobile"} ref={mobileNav}>
          <div className={"mdl-header-mobile__container"}>
            <div className={"mdl-header-mobile__nav"}>
              <AtmLink inline to={ENUMS.ROUTE_ABOUT_US} onClick={toggleMobile}>
                {t("aboutUs")}
              </AtmLink>
              <AtmLink inline to={ENUMS.ROUTE_SERVICES} onClick={toggleMobile}>
                {t("services")}
              </AtmLink>
              <AtmLink
                inline
                to={ENUMS.ROUTE_OUR_PEOPLE}
                onClick={toggleMobile}
              >
                {t("ourPeople")}
              </AtmLink>
              <AtmLink inline to={ENUMS.ROUTE_PROJECTS} onClick={toggleMobile}>
                {t("projects")}
              </AtmLink>
              <AtmLink inline to={ENUMS.ROUTE_CAREERS} onClick={toggleMobile}>
                {t("careers")}
              </AtmLink>
              <AtmLink inline to={ENUMS.ROUTE_CONTACT} onClick={toggleMobile}>
                {t("contact")}
              </AtmLink>
            </div>
            <div className={"mdl-header__lang"} onClick={changeLanguage}>
              {i18n.language === "en" ? "MK" : "EN"}
            </div>
            <div className={"mdl-header-mobile__social-media"}>
              <a
                href={
                  "https://www.linkedin.com/company/georgi-dimitrov-attorneys/"
                }
                target={"_blank"}
                rel={"noreferrer"}
              >
                LinkedIn
              </a>
            </div>
            <div>© Georgi Dimitrov Attorneys, 2025</div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
